// Componentes
import Layout from '../views/Layout'
import Login from '../components/LoginForm/Login'
import { structure } from '@/config'

const routes = [
	{
		path:'/panel',
		component: Layout,
		authCheck: true,
		children: structure
	},
	{
		path: '/login',
    component: Login,
    authCheck: true
	},
	{
		path: '*',
		redirect: '/login',
	}
]

export default routes
